export default __webpack_public_path__ + "static/media/intro2.30252ba9.mp3";